import "../CustomTable/CustomTable.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Addclients from "../Addclients/Addclients";
import SetStatus from "../SetStatus/SetStatus"; //  Added import
import { MoreOutlined } from "@ant-design/icons";
import Editclient from "../Editclients/Editclient";
import { deleteClientApi } from "../../Services/DeleteclientService/DelectclientApi";
import AlertMessage from "../AlertMessage/AlertMessage";
import { FaSortDown, FaSortUp } from "react-icons/fa6";
// import { DateFormatter } from "../CommonUI/DateFormatter";
import ConfirmPopup from "../ConfirmPopup/ConfirmPopup";
import FlagIcon from "../FlagIcon/FlagIcon";
import { ResendInviteService  } from "../../Services/BusinessClientsService/BusinessClientsService";
import { useDispatch, useSelector } from "react-redux";
import { clearSorting, setSorting } from "../../Reducer/SortingSliceReducer";
import { useLocation } from "react-router-dom";
import { formatForInput } from "../../Utils/datepickerFormat";
import EditUser from "../EditUser/EditUser";
import { int } from "aws-sdk/clients/datapipeline";
import { ResendInviteServiceUser } from "../../Services/UserManagementService/UserManagementService";
interface Column {
  key: string;
  title: string | JSX.Element;
  dataIndex?: string;
  width?: number;

  isLink?: boolean;
  isStatus?: boolean;
  isUrl?: boolean;
  isError?: boolean;
  isCheckbox?: boolean;
  showSortArrows?: boolean;
  isDate?: boolean;
  isActions?: boolean; // action column
  useTag?: boolean; //  existing property
  useCircleStatus?: boolean; //  new property for circle status
  handleClearSelection?: () => void;
  isFlag?: boolean;
  isSticky?: boolean;
  isDash?: boolean;
  isRedIfPositive?: boolean;
  isDeadline?: boolean;
  isItemDelay?: boolean;
  isOldestItem?: boolean;
  // below is for usermanagement - need to be refactored
  status?: int;
}

export type TableRowAction =
  | "edit"
  | "delete"
  | "deactivate"
  | "resendEmail"
  | "reactivate";

interface CommonTableProps<T> {
  columns: Column[];
  data: T[];
  onRowCheckboxChange?: (row: T, checked: boolean) => void;
  selectedRowKeys?: (string | number)[];
  onRowClick?: (row: T) => void;
  pendingAction?: TableRowAction | null;
  onPendingActionHandled?: () => void;
  onRow?: (
    record: T,
    index: number,
  ) => React.HTMLAttributes<HTMLTableRowElement>;
  selectAll?: boolean;
  handleSelectAll?: (checked: boolean) => void;
  handleClearSelection?: () => void;
  rowKey?: string;
  loadMoreInvoicesOnScroll?: any;
  infinityScroll?: boolean;
  stageId?: number;
  userId?: string;
  sortInvoices?: (order: boolean, key: string) => void;
  fetchData?: () => void;
  onFlagClick?: (row: T) => void;
  isuser?: boolean;
  totalCount?: number;
  // Overrides the row delete action's API call. Falls back to the default
  // deleteClientApi (business clients) when not provided — e.g. UserManagement
  // passes DeleteUserService here so "Delete" on a user row deletes the user
  // instead of a business client.
  deleteService?: (id: string) => Promise<any>;
    DeactivateUserService?: {
    deactivate: (id: string) => Promise<any>;
    activate: (id: string) => Promise<any>;
  };
   name?: string;
   isDuplicate?: boolean;
}

const CommonTable = <T extends { id: any ; [key: string]: any }>({
  sortInvoices,
  infinityScroll,
  columns,
  data,
  onRowCheckboxChange,
  selectedRowKeys = [],
  pendingAction = null,
  onPendingActionHandled,
  onRow,
  onRowClick,
  selectAll,
  handleSelectAll,
  handleClearSelection,
  loadMoreInvoicesOnScroll,
  stageId,
  userId,
  fetchData,
  onFlagClick,
  isuser = false,
  totalCount,
  deleteService,
  DeactivateUserService,
  name = "client",
  // isDuplicate
}: CommonTableProps<T>) => {
  console.log("the data in co,mmon table", data);
  const bottomPullDistanceRef = useRef(0);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [sortedData, setSortedData] = useState<T[]>(data);
  const [openMenuRow, setOpenMenuRow] = useState<string | number | null>(null);
  const listRef = useRef<HTMLDivElement | null>(null);
  //  Addclients modal open state
  const [isAddClientsOpen, setIsAddClientsOpen] = useState(false);
  const [isAddEditclientOpen, setIsEditclientOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const headerCheckboxRef = useRef<HTMLInputElement>(null);
  const [isdeleteclick, setIsdeleteclick] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  // States for ConfirmPopup
  const [openPopup, setOpenPopup] = useState(false);
  const [actionRows, setActionRows] = useState<any[]>([]);
  const [popupAction, setPopupAction] = useState<"delete" | "deactivate" | "resendEmail" | "reactivate">("delete");
  const sorting = useSelector((state: any) => state.sorting.sortingData);
  const [isScrolledHorizontally, setIsScrolledHorizontally] = useState(false);
  const isInboxPage = location.pathname.includes("/inbox");
  const [activeSorting, setActiveSorting] = useState<{
    key: string;
    order: "asc" | "desc";
  } | null>({
    key: sorting.key || "",
    order: sorting.order || "desc",
  });
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);

  useEffect(() => {
    dispatch(setSorting({ key: "", order: "desc" }));
  }, [location.pathname]);

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  // close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        !target.closest(".row-actions-menu") &&
        !target.closest(".row-actions-trigger")
      ) {
        setOpenMenuRow(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
console.log("Name:", name);
  const handleSort = (key: string) => {
    handleClearSelection && handleClearSelection();

    if (activeSorting?.key !== key) {
      // Different column — reset to ascending
      const newSorting = { key, order: "asc" as const };
      setActiveSorting(newSorting);
      dispatch(setSorting(newSorting));
      sortInvoices && sortInvoices(false, key);
    } else if (activeSorting.order === "asc") {
      // Same column, currently asc — go desc
      const newSorting = { key, order: "desc" as const };
      setActiveSorting(newSorting);
      dispatch(setSorting(newSorting));
      sortInvoices && sortInvoices(true, key);
    } else {
      // Same column, currently desc — reset
      setActiveSorting(null);
      dispatch(setSorting({ key: "", order: "asc" }));
      sortInvoices && sortInvoices(false, "default");
    }
  };

  // PARTIAL SELECT CHECK
  const isIndeterminate =
    selectedRowKeys.length > 0 && selectedRowKeys.length < data.length;

  // SET MINUS SYMBOL
  useEffect(() => {
    if (headerCheckboxRef.current) {
      headerCheckboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate, selectedRowKeys]);

  const allSelected =
    typeof selectAll === "boolean"
      ? selectAll
      : selectedRowKeys.length === data.length && data.length > 0;

  const handleHeaderCheckboxChange = (checked: boolean) => {
    if (handleSelectAll) {
      handleSelectAll(checked);
    } else if (onRowCheckboxChange) {
      data.forEach((row) => onRowCheckboxChange(row, checked));
    }
  };

  const handleDelete = (row: any) => {
    setActionRows([row]);
    setOpenPopup(true);
    setOpenMenuRow(null);
  };

  const getRowId = (row: any) => row?.clientId || row?.userId || row?.id;

  const confirmDelete = async () => {
    if (!actionRows.length) return;
    try {
      for (const row of actionRows) {
        const userId = getRowId(row);
        if (!userId) {
          AlertMessage({ text: "User ID not found!", type: "error" });
          return;
        }
        await (deleteService ?? deleteClientApi)(userId);
      }

      AlertMessage({
        text: deleteService
          ? actionRows.length > 1
            ? "Users deleted successfully!"
            : "User deleted successfully!"
          : actionRows.length > 1
            ? "Clients deleted successfully!"
            : "Client deleted successfully!",
        type: "success",
      });
      setOpenPopup(false);
      setActionRows([]);
      handleClearSelection && handleClearSelection();
      fetchData && fetchData();
    } catch (error) {
      console.error("Failed to delete client:", error);
      AlertMessage({ text: "Failed to delete client!", type: "error" });
    }
  };

  const confirmDeactivate = async () => {
    if (!actionRows.length) return;
    if (!DeactivateUserService) return;

    try {
      for (const row of actionRows) {
        const userId = row?.userId ?? row?.id;
        if (!userId) {
          AlertMessage({ text: "User ID not found!", type: "error" });
          return;
        }
        await DeactivateUserService.deactivate(userId);
      }
      AlertMessage({
        text:
          actionRows.length > 1
            ? "Users deactivated successfully!"
            : "User deactivated successfully!",
        type: "success",
      });
      setOpenPopup(false);
      setActionRows([]);
      handleClearSelection && handleClearSelection();
      fetchData && fetchData();
    } catch (error) {
      console.error("Failed to deactivate user", error);
      AlertMessage({ text: "Failed to deactivate user!", type: "error" });
    }
  };

  const confirmReactivate = async () => {
    if (!actionRows.length) return;
    if (!DeactivateUserService) return;

    try {
      for (const row of actionRows) {
        const userId = row?.userId ?? row?.id;
        if (!userId) {
          AlertMessage({ text: "User ID not found!", type: "error" });
          return;
        }
        await DeactivateUserService.activate(userId);
      }
      AlertMessage({
        text:
          actionRows.length > 1
            ? "Users reactivated successfully!"
            : "User reactivated successfully!",
        type: "success",
      });
      setOpenPopup(false);
      setActionRows([]);
      handleClearSelection && handleClearSelection();
      fetchData && fetchData();
    } catch (error) {
      console.error("Failed to deactivate user", error);
      AlertMessage({ text: "Failed to deactivate user!", type: "error" });
    }
  };

const handleConfirmAction = async () => {
  if (!actionRows.length) return;

  if (popupAction === "delete") {
    await confirmDelete();
  } else if (popupAction === "deactivate") {
    await confirmDeactivate();
  } else if (popupAction === "resendEmail") {
    if (name === "User") {
      for (const row of actionRows) {
        await handleResendEmailUser(row?.id);
      }
    } else {
      for (const row of actionRows) {
        await handleResendEmail(row?.clientId || row?.id);
      }
    }

    setOpenPopup(false);
    setActionRows([]);
    handleClearSelection && handleClearSelection();
  }
  else if (popupAction === "reactivate") {
    await confirmReactivate();
  }
};

  const getStatusText = (value: number) => {
    switch (value) {
      case 1:
        return "uploaded";
      case 2:
        return "ai extraction failed";
      case 3:
        return "saved";
      case 4:
        return "general error";
      case 6:
        return "s3 error";
      case 7:
        return "invoice queued";
      default:
        return "Unknown";
    }
  };

  const getCircleStatusText = (value: number | string) => {
    switch (value) {
      case 0:
      case "pending":
        return { text: "Pending", color: "#ef6713ff" };
      case 1:
      case "active":
        return { text: "Active", color: "green" };
      case 2:
      case "deactive":
        return { text: "Deactivated", color: "red" };
      case 3:
      case "Expired":
        return { text: "Expired", color: "orange" };
      default:
        return { text: "Unknown", color: "gray" };
    }
  };

  const handleResendEmail = async (clientId: string) => {
    const res = await ResendInviteService(clientId);
  
    if (res?.status?.statusCode === 200) {
      AlertMessage({
        text: res?.message || "Email resent successfully",
        type: "success",
      });
    } else {
      AlertMessage({
        text: res?.message || "Failed to Resend Invite",
        type: "error",
      });
    }
  };

  const handleResendEmailUser = async (clientId: string) => {
    try {

      const res = await ResendInviteServiceUser(clientId);

      if (res?.status?.statusCode === 200) {
        AlertMessage({
          text: res?.message || "Email resent successfully",
          type: "success",
        });
      } else {
        AlertMessage({
          text: res?.message || "Failed to Resend Invite",
          type: "error",
        });
      }
    } catch (error: any) {
      console.error("Error resending invite:", error);

      AlertMessage({
        text: error?.response?.data?.message || "Failed to Resend Invite",
        type: "error",
      });
    }
    finally {
      fetchData && fetchData(); // Refresh the data after resending the email 
    }
  };

  const getSelectedRows = () =>
    data.filter((row) => selectedRowKeys.includes(row.id));

  useEffect(() => {
    if (!pendingAction) return;

    const runPendingAction = async () => {
      const selected = getSelectedRows();
      if (selected.length === 0) {
        onPendingActionHandled?.();
        return;
      }

      if (pendingAction === "edit") {
        if (selected.length !== 1) {
          AlertMessage({
            text: "Please select a single item to edit",
            type: "error",
          });
          onPendingActionHandled?.();
          return;
        }
        const row = selected[0];
        setSelectedRow(row);
        setIsEditclientOpen(!isuser);
        setIsEditUserOpen(isuser);
        setShowModal(true);
      } else if (pendingAction === "delete") {
        setActionRows(selected);
        setPopupAction("delete");
        setOpenPopup(true);
      } else if (pendingAction === "deactivate") {
        const rows = selected.filter((row) => row.status === 1);
        if (rows.length) {
          setActionRows(rows);
          setPopupAction("deactivate");
          setOpenPopup(true);
        }
      } else if (pendingAction === "reactivate") {
        const rows = selected.filter((row) => row.status === 2);
        if (rows.length) {
          setActionRows(rows);
          setPopupAction("reactivate");
          setOpenPopup(true);
        }
      } else if (pendingAction === "resendEmail") {
        const rows = selected.filter((row) => row.status === 3);
        if (rows.length) {
          if (isuser) {
            setActionRows(rows);
            setPopupAction("resendEmail");
            setOpenPopup(true);
          } else {
            for (const row of rows) {
              await handleResendEmail(row.clientId || row.id);
            }
          }
        }
      }

      onPendingActionHandled?.();
    };

    runPendingAction();
    // Intentionally keyed only on pendingAction so each dropdown choice runs once
    // with the selection captured in this render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingAction]);

  const HandleOnScroll = (e: any) => {
    if (!infinityScroll) {
      return;
    }
    const div = e.currentTarget;

    const isAtBottom =
      div.scrollTop + div.clientHeight >= div.scrollHeight - 50;
    //  Math.abs(div.scrollHeight - div.scrollTop - div.clientHeight) < 1;

    if (!isAtBottom) {
      bottomPullDistanceRef.current = 0; // reset pull
      return;
    }

    // User is pulling down when at bottom
    bottomPullDistanceRef.current++;

    // Trigger only when user actually pulls (2–3 ticks)
    if (bottomPullDistanceRef.current === 1) {
      loadMoreInvoicesOnScroll();
    }
  };

  // List of keys that should be right-aligned
  const rightAlignedKeys = [
    "total",
    "tax",
    "Tax Rate",
    "Payment",
    "totalAmount",
    "taxAmount",
    "netAmount",
    "discountAmount",
  ];
  if (data.length === 0) return <h1>No invoices found for this client.</h1>;

  // Compute cumulative left offsets for sticky columns
  const stickyOffsets: Record<string, number> = {};

  let stickyLeft = 0;

  columns.forEach((col) => {
    if (col.isSticky) {
      stickyOffsets[col.key] = stickyLeft;
      stickyLeft += col.width || 150;
    }
  });

  const getStickyStyle = (col: Column): React.CSSProperties =>
    col.isSticky
      ? {
          position: "sticky",
          left: stickyOffsets[col.key],
          backgroundColor: "var(--color-bg-subtle)",
          zIndex: 2,

          boxShadow:
            col.key === "Email" && isScrolledHorizontally
              ? "3px 0 0px rgba(0,0,0,0.15)"
              : undefined,
        }
      : {};

  const SELECTION_BAR_HEIGHT = 36;
  const headerTopOffset = selectedRowKeys.length > 0 ? SELECTION_BAR_HEIGHT : 0;

  const getStickyHeaderStyle = (col: Column): React.CSSProperties =>
    col.isSticky
      ? {
          position: "sticky",
          top: headerTopOffset,
          left: stickyOffsets[col.key],
          backgroundColor: "var(--table-header-bg)",
          zIndex: 3,

          boxShadow:
            col.key === "Email" && isScrolledHorizontally
              ? "0px 0 6px rgba(0,0,0,0.15)"
              : undefined,
        }
      : {
          position: "sticky",
          top: headerTopOffset,
          backgroundColor: "var(--table-header-bg)",
          zIndex: 2,
        };

  return (
    <div
      className="table-wrapper"
      onScroll={(e) => {
        HandleOnScroll(e);

        const target = e.currentTarget;
        setIsScrolledHorizontally(target.scrollLeft > 0);
      }}
      ref={listRef}
    >
      {/*  Selected count indicator */}
      {selectedRowKeys.length > 0 && (
        <div className="table-selection-bar">
          <span>
            <span className="table-selection-bar__icon" aria-hidden="true">
              ⓘ
            </span>
            {selectedRowKeys.length} of total {totalCount} items are selected
          </span>
        </div>
      )}

      <table className="custom-tb">
        <thead>
          <tr
            className="custom-tr"
            style={{
              maxWidth: "200px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {columns.map((col) => {
              const isRightAligned = rightAlignedKeys.includes(
                (col.dataIndex || col.key) as string,
              );
              return col.isCheckbox ? (
                <th
                  key={col.key}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    textAlign: "center",
                    ...getStickyHeaderStyle(col),
                  }}
                >
                  <input
                    placeholder="checkbox"
                    ref={headerCheckboxRef}
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) =>
                      handleHeaderCheckboxChange(e.target.checked)
                    }
                  />
                </th>
              ) : col.isFlag ? (
                <th
                  key={col.key}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    textAlign: "center",
                    ...getStickyHeaderStyle(col),
                  }}
                />
              ) : (
                <th
                  key={col.key}
                  className={`sortable ${
                    sortKey === col.key
                      ? sortOrder === "asc"
                        ? "sort-asc"
                        : "sort-desc"
                      : ""
                  }`}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    textAlign: isRightAligned ? "right" : "left",
                    ...getStickyHeaderStyle(col),
                  }}
                >
                  <div
                    className="custom-th"
                    style={{
                      justifyContent: isRightAligned
                        ? "flex-end"
                        : "space-between",
                    }}
                  >
                    <span className="custom-th__title">{col.title}</span>
                    {col.showSortArrows !== false && !col.isActions && (
                      <span
                        className="sort-arrows"
                        onClick={() => handleSort(col.key)}
                        style={{
                          cursor: "pointer",
                          display: "inline-flex",
                          flexDirection: "column",
                        }}
                      >
                        <FaSortUp
                          className="up"
                          size={14}
                          color={
                            activeSorting?.key === col.key &&
                            activeSorting?.order === "asc"
                              ? "red"
                              : "grey"
                          }
                        />
                        <FaSortDown
                          className="down"
                          size={14}
                          color={
                            activeSorting?.key === col.key &&
                            activeSorting?.order === "desc"
                              ? "red"
                              : "grey"
                          }
                        />
                      </span>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {sortedData.map((row, idx) => (
            <tr
              key={row.id}
              data-row-id={row.id}
              onClick={() => onRowClick && onRowClick(row)}
              className="custom-td"
              
             
              {...(onRow ? onRow(row, idx) : {})}
            >
              {columns.map((col) => {
                const columnKey = (col.dataIndex || col.key) as string;
                const isRightAligned = rightAlignedKeys.includes(columnKey);

                if (col.isCheckbox) {
                  return (
                    <td
                      key={col.key}
                      className="tabledata-checkbox"
                      style={{
                        width: col.width,
                        minWidth: col.width,
                        maxWidth: col.width,
                        textAlign: "center",
                        ...getStickyStyle(col),
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        placeholder="checkbox"
                        type="checkbox"
                        checked={selectedRowKeys.includes(row.id)}
                        onChange={(e) =>
                          onRowCheckboxChange &&
                          onRowCheckboxChange(row, e.target.checked)
                        }
                      />
                    </td>
                  );
                }
                // Add this block before the final `else` in the column renderer
                if ((col as any).isFlag) {
                  return (
                    <td
                      key={col.key}
                      style={{ width: "40px", textAlign: "center" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                        onClick={() => onFlagClick && onFlagClick(row)}
                      >
                        <FlagIcon
                          size={16}
                          filled={!!row.isFlagged}
                          color={row.isFlagged ? "#ef4444" : "#9ca3af"}
                        />
                      </span>
                    </td>
                  );
                }

                if (col.isActions) {
                  return (
                    <td
                      key={col.key}
                      style={{
                        width: col.width,
                        minWidth: col.width,
                        maxWidth: col.width,

                        position: "relative",
                        textAlign: "center",

                        ...getStickyStyle(col),
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span
                        className="row-actions-trigger"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMenuRow(
                            openMenuRow === row.id ? null : row.id,
                          );
                        }}
                      >
                        <MoreOutlined />
                      </span>

                      {openMenuRow === row.id && (
                        <div
                          className="row-actions-menu"
                          style={{ left: isuser ? "-80px" : "0px" }}
                        >
                          {/* Edit - Available for all statuses */}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEditclientOpen(!isuser);
                              setIsEditUserOpen(isuser);
                              setOpenMenuRow(null);
                              setSelectedRow(row);
                              setShowModal(true);
                            }}
                          >
                            Edit
                          </button>

                          {/* Delete - Available for all statuses */}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsdeleteclick(true);
                              setPopupAction("delete");
                              handleDelete(row);
                            }}
                          >
                            Delete
                          </button>
                          {/* Active User -> Deactivate */}
                          {row.status === 1 && isuser && (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setActionRows([row]);
                                setPopupAction("deactivate");
                                setOpenPopup(true);
                                setOpenMenuRow(null);
                              }}
                            >
                              Deactivate User
                            </button>
                          )}
                          {/* Expired -> Resend Email */}
                          {row.status === 3 && isuser && (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setActionRows([row]);
                                setPopupAction("resendEmail");
                                setOpenPopup(true);
                                setOpenMenuRow(null);
                              }}
                            >
                              Resend Invite
                            </button>
                          )}

                          {/* Deactivated User -> Reactivate */}
                          {row.status === 2 && isuser && (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setActionRows([row]);
                                setPopupAction("reactivate");
                                setOpenPopup(true);
                                setOpenMenuRow(null);
                              }}
                            >
                              Reactivate User
                            </button>
                          )}

                          {/* Expired -> Resend Email */}
                          {!isuser && row.status === 3 && (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPopupAction("resendEmail");
                                handleResendEmail(row.clientId);
                                setOpenMenuRow(null);
                              }}
                            >
                              Resend Invite
                            </button>
                          )}


                        </div>
                      )}


                    </td>
                  );
                }

                const value = row[col.dataIndex || col.key];

                if (col.isLink) {
                  return <td key={col.key}>{value}</td>;
                } else if (col.isStatus) {
                  return (
                    <td
                      key={col.key}
                      style={{
                        width: col.width,
                        minWidth: col.width,
                        maxWidth: col.width,

                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",

                        ...getStickyStyle(col),
                      }}
                    >
                      {col.useCircleStatus ? (
                        (() => {
                          const status = getCircleStatusText(value);
                          return (
                            <div className="table-cell-status table-cell-status--circle">
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor: status.color,
                                }}
                              ></span>
                              <span>{status.text}</span>
                            </div>
                          );
                        })()
                      ) : col.useTag ? (
                        <div className="table-cell-status">
                          <span>{getStatusText(value)}</span>
                        </div>
                      ) : (
                            <span className="table-cell-status">
                              <SetStatus
                                stageId={value}
                                archived={row.archiveStatus}
                                isDuplicate={isInboxPage && row.isDuplicate === true}
                              />
                            </span>
                      )}
                    </td>
                  );
                } else if (col.isUrl) {
                  return (
                    <td key={col.key} className="table-cell-padded">
                      {value ? (
                        <a
                          href={value}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link
                        </a>
                      ) : (
                        <span>N/A</span>
                      )}
                    </td>
                  );
                } else if (col.isError) {
                  return <td key={col.key}>{value}</td>;
                } else {
                  const isOverdue =
                    col.isDeadline && value && new Date(value) < new Date();

                  const isDelayed =
                    col.isItemDelay && value != null && Number(value) > 30;

                  const isOldBacklog = (() => {
                    if (!col.isOldestItem || !value) return false;
                    const daysDiff =
                      (Date.now() - new Date(value).getTime()) /
                      (1000 * 60 * 60 * 24);
                    return daysDiff > 90;
                  })();

                  const isFailedAlert =
                    col.isRedIfPositive && Number(value) > 0;

                  let displayValue: React.ReactNode;

                  if (
                    value == null ||
                    value === "" ||
                    (value === 0 && col.isDash)
                  ) {
                    // Numeric count columns show "0"; date/text columns show "—"
                    const isCountCol = [
                      "items",
                      "inbox",
                      "failedProcessed",
                      "pending",
                      "to_Review",
                      "ready",
                      "exported",
                      "archived",
                      "mobileUsers",
                    ].includes(col.dataIndex || "");
                    displayValue = isCountCol ? "0" : "-";
                  } else if (col.isDate || col.isDeadline || col.isOldestItem) {
                    displayValue = formatForInput(value) || "-"; // Null check is covered in the imported function
                    // ? new Date(value).toLocaleDateString("en-GB", {
                    //     day: "2-digit",
                    //     month: "short",
                    //     year: "numeric",
                    //   })
                    // : "—";
                  } else if (col.isItemDelay) {
                    displayValue = value != null ? `${value} days` : "—";
                  } else {
                    displayValue = value;
                  }

                  const highlight =
                    isOverdue || isDelayed || isFailedAlert
                      ? "#d32f2f"
                      : isOldBacklog
                        ? "#e65100" // amber
                        : undefined;

                  return (
                    <td
                      key={col.key}
                      className="tabledata"
                      style={{
                        maxWidth: "200px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        color: highlight,
                        fontWeight: highlight ? 500 : undefined,
                        ...getStickyStyle(col),
                      }}
                    >
                      {displayValue}
                    </td>
                  );
                }
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <ConfirmPopup
        isOpen={openPopup}
        title={
          popupAction === "delete"
            ? `Delete ${name}`
            : popupAction === "deactivate"
              ? "Deactivate User"
              : popupAction === "resendEmail"
                ? "Resend Invite"
                : "Reactivate User"
        }
        message={
          <>
            <span
              style={{
                fontWeight: "bold",
                display: "block",
                marginBottom: "15px",
              }}
            >
              {popupAction === "delete"
                ? `Are you sure you want to delete ${
                    actionRows.length > 1
                      ? `these ${actionRows.length} ${name}s`
                      : `this ${name}`
                  }?`
                : popupAction === "deactivate"
                  ? `Are you sure you want to deactivate ${
                      actionRows.length > 1
                        ? `these ${actionRows.length} users`
                        : "this user"
                    }?`
                  : popupAction === "resendEmail"
                    ? `Are you sure you want to resend the invitation email ${
                        actionRows.length > 1
                          ? `to these ${actionRows.length} users`
                          : "to this user"
                      }?`
                    : `Are you sure you want to reactivate ${
                        actionRows.length > 1
                          ? `these ${actionRows.length} users`
                          : "this user"
                      }?`}
            </span>

            <span
              style={{
                fontWeight: "bold",
                color: "var(--color-danger-alt)",
                backgroundColor: "#ffeaea",
                padding: "2px 6px",
                borderRadius: "4px",
              }}
            >
              {actionRows.length === 1
                ? actionRows[0]?.email || actionRows[0]?.name || "Client"
                : actionRows
                    .slice(0, 3)
                    .map((row) => row?.email || row?.name)
                    .filter(Boolean)
                    .join(", ") +
                  (actionRows.length > 3
                    ? ` +${actionRows.length - 3} more`
                    : "")}
            </span>
          </>
        }
        onConfirm={handleConfirmAction}
        onCancel={() => {
          setOpenPopup(false);
          setActionRows([]);
        }}
      />

      {/* Addclients modal */}
      {isAddClientsOpen && (
        <Addclients
          visible={true}
          onClose={() => setIsAddClientsOpen(false)}
          rowData={selectedRow}
        />
      )}
      {isAddEditclientOpen && (
        <Editclient
          visible={true}
          onClose={() => setIsEditclientOpen(false)}
          rowData={selectedRow}
          data={fetchData}
        />
      )}
      {isEditUserOpen && (
        <EditUser
          visible={true}
          onClose={() => setIsEditUserOpen(false)}
          rowData={selectedRow}
          data={fetchData}
        />
      )}
    </div>
  );
};

export default CommonTable;
function onSuccess() {
  throw new Error("Function not implemented.");
}